import { TextButton, typography } from '@joor/design-system'
import styled from 'styled-components/macro'

import { OrderPriceModifier, OrderPriceRange } from '__generated__/atlas-types'

import { formatCurrencyPriceRangeStr } from '../../ProductsWidget/formatters'
import CustomFees from './CustomFees'
import { FinancialSummaryIds } from 'features/Orders/Review/review.ids'

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.total {
    background-color: var(--color-primary-100);
    border-radius: 3px;
    margin-bottom: 0;
    padding: 8px;
  }
`

const ConceptText = styled.p`
  margin-bottom: 0 !important;
  ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-800);
  display: flex;
  align-items: center;
  gap: 3px;
  display: flex;
  align-items: center;
  gap: 3px;

  &.light {
    color: var(--color-primary-500);
  }

  &.small {
    font-size: 10px;
  }

  &.padding-top {
    padding-top: 8px;
  }
`

const NumericText = styled.p`
  ${typography.numeric.primaryActive.body3}
  text-align: end;

  &.red {
    color: var(--color-error-700);
  }

  &.green {
    color: var(--color-success-500);
  }
`

const GatedFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px dashed var(--color-primary-300);
  border-radius: 5px;
  padding: 12px;
  margin-top: 10px;

  p {
    color: var(--color-primary-300);
  }
`

type Props = {
  currencyCode: string
  amounts: {
    taxes: string
    customFees: OrderPriceModifier[]
    totalDue: OrderPriceRange
  }
}

const GatedFields = ({ currencyCode, amounts }: Props) => {
  return (
    <GatedFieldsWrapper>
      <Row>
        <ConceptText>Taxes</ConceptText>
        <NumericText>{amounts.taxes}</NumericText>
      </Row>
      <CustomFees
        currencyCode={currencyCode}
        customFees={amounts.customFees}
        disabled
      />
      <Row className="total">
        <ConceptText>Total due</ConceptText>
        <NumericText>
          {formatCurrencyPriceRangeStr(currencyCode, amounts.totalDue)}
        </NumericText>
      </Row>
      <TextButton
        id={FinancialSummaryIds.UnlockFieldsId}
        iconName="unlock"
        onClick={() =>
          window.open('https://www.joor.com/joor-pay-application', '_blank')
        }
      >
        Unlock Today
      </TextButton>
    </GatedFieldsWrapper>
  )
}

export default GatedFields
